import React from "react";
import { useTranslation } from "react-i18next";

interface RatingInfoContentProps {
  dimension: "knowledge" | "skills" | "attitude";
}

const LEVELS = ["5", "4", "3", "2", "1"] as const;

export const RatingInfoContent: React.FC<RatingInfoContentProps> = ({ dimension }) => {
  const { t } = useTranslation();

  return (
    <div className="text-sm">
      <div className="border-b border-border pb-2 mb-3">
        <h3 className="text-lg font-semibold text-destructive flex items-center gap-2">
          <span className="inline-block">📌</span>
          {t(`form.ratingInfo.${dimension}.title`)}
        </h3>
        <p className="text-muted-foreground mt-1">
          {t(`form.ratingInfo.${dimension}.subtitle`)}
        </p>
      </div>

      <div className="space-y-4">
        {LEVELS.map((level) => {
          const items = t(`form.ratingInfo.${dimension}.items.${level}`, {
            returnObjects: true,
          }) as string[];

          return (
            <div key={level}>
              <h4 className="font-semibold">{t(`form.ratingInfo.levels.${level}`)}</h4>
              <p className="mb-1">{t("form.ratingInfo.behaviorLabel")}</p>
              <ul className="space-y-1">
                {Array.isArray(items) &&
                  items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
                      <span>{item}</span>
                    </li>
                  ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RatingInfoContent;
